import React from 'react';

interface ExternalWineInfoTableProps {
  mongoId: string;
  wineVinId: string;
  vintage: string;
  fromExternalInput?: boolean;
}

const ExternalWineInfoTable: React.FC<ExternalWineInfoTableProps> = ({ 
  mongoId, 
  wineVinId, 
  vintage,
  fromExternalInput
}) => {
  return (
    <div className="mb-5 border rounded-lg">
      <div className="grid grid-cols-1">
        <div className="border-b">
          <div className="grid grid-cols-12 border-b">
            <div className="col-span-2 font-medium text-sm py-3 px-4 bg-gray-50 border-r">Mongo ID</div>
            <div className="col-span-10 py-3 px-4">{mongoId}</div>
          </div>
          <div className="grid grid-cols-12 border-b">
            <div className="col-span-2 font-medium text-sm py-3 px-4 bg-gray-50 border-r">Wine Vin ID</div>
            <div className="col-span-10 py-3 px-4">{wineVinId}</div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-2 font-medium text-sm py-3 px-4 bg-gray-50 border-r">Vintage</div>
            <div className="col-span-10 py-3 px-4">{vintage}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalWineInfoTable;
